/**
 * MenuItem is part of Menu and specifically a child of MenuContent.
 * MenuItems should have a 'key' prop specified.
 * https://facebook.github.io/react/docs/lists-and-keys.html#keys
 *
 * Example:
 *   <MenuItem key="item 1"><a href="example.com">Click me</a><MenuItem>
 */
import classNames from 'classnames';
import { Box } from '@mui/material';
import React from 'react';

const rootSx = {
  height: '100%',
  width: '100%',
  margin: 0,
};

const MenuItem = ({ children, className = null, rootClassName = '' }) => (
  <Box
    className={classNames(rootClassName, className)}
    component="li"
    role="menuitem"
    sx={rootClassName ? undefined : rootSx}
  >
    {children}
  </Box>
);

export default MenuItem;
